import { assign } from 'xstate5';

import { type OrderingMachineAction } from './ordering-machine.actions.types';
import { orderingMachineLog } from './ordering-machine.logger';

// ─────────────────────────────────────────────────────────────────────────────

const handlePostOrderPurchaseModal: OrderingMachineAction = () => {
  orderingMachineLog.debug(
    'Please provide `handlePostOrderPurchaseModal` action.',
  );
};

const handlePostOrderNotifications: OrderingMachineAction = () => {
  orderingMachineLog.debug(
    'Please provide `handlePostOrderNotifications` action.',
  );
};

const handlePostOrderTracking: OrderingMachineAction = () => {
  orderingMachineLog.debug('Please provide `handlePostOrderTracking` action.');
};

const handlePostOrderHistory: OrderingMachineAction = () => {
  orderingMachineLog.debug('Please provide `handlePostOrderHistory` action.');
};

const handlePostOrderAppReview: OrderingMachineAction = () => {
  orderingMachineLog.debug('Please provide `handlePostOrderAppReview` action.');
};

const navigatePostOrder: OrderingMachineAction = () => {
  orderingMachineLog.debug('Please provide `navigatePostOrder` action.');
};

const storeOrderPostSubmission: OrderingMachineAction = assign({
  orderId({ context, event }) {
    const output = event as {
      output?: { order?: { id?: string; hasEarnedLoyaltyPoints?: boolean } };
    };
    return output?.output?.order?.id ?? context.orderId;
  },
  hasEarnedLoyaltyPoints({ context, event }) {
    const output = event as {
      output?: { order?: { hasEarnedLoyaltyPoints?: boolean } };
    };
    return (
      output?.output?.order?.hasEarnedLoyaltyPoints ??
      context.hasEarnedLoyaltyPoints
    );
  },
});

// ─────────────────────────────────────────────────────────────────────────────

export const OrderingPostOrderActions = {
  storeOrderPostSubmission,
  handlePostOrderPurchaseModal,
  handlePostOrderNotifications,
  handlePostOrderTracking,
  handlePostOrderHistory,
  handlePostOrderAppReview,
  navigatePostOrder,
};
